var _circle, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FEEDE7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9996,
    cy: 14.6153,
    rx: 6.15385,
    ry: 6.15385,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0006,
    cy: 14.6153,
    rx: 3.46154,
    ry: 3.46154,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.9995,
    cy: 14.6155,
    rx: 1.15384,
    ry: 1.15384,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0907 18.8387C12.7295 18.8387 10.8086 16.9442 10.8086 14.6153C10.8086 12.2865 12.7295 10.3919 15.0907 10.3919C17.4518 10.3919 19.3727 12.2866 19.3727 14.6153C19.3727 16.9442 17.4518 18.8387 15.0907 18.8387ZM15.0907 11.3598C13.2706 11.3598 11.7899 12.8203 11.7899 14.6154C11.7899 16.4105 13.2706 17.8709 15.0907 17.8709C16.9107 17.8709 18.3914 16.4105 18.3914 14.6154C18.3914 12.8203 16.9107 11.3598 15.0907 11.3598Z",
    fill: "#FA7548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0904 16.4731C14.0519 16.4731 13.207 15.6398 13.207 14.6155C13.207 13.5912 14.0519 12.7579 15.0904 12.7579C16.1289 12.7579 16.9738 13.5912 16.9738 14.6155C16.9738 15.6398 16.1289 16.4731 15.0904 16.4731ZM15.0904 13.7258C14.593 13.7258 14.1883 14.1249 14.1883 14.6155C14.1883 15.1061 14.593 15.5052 15.0904 15.5052C15.5879 15.5052 15.9925 15.1061 15.9925 14.6155C15.9925 14.1249 15.5879 13.7258 15.0904 13.7258Z",
    fill: "#FA7548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0901 21.1537C11.4347 21.1537 8.46094 18.2206 8.46094 14.6154C8.46094 11.0102 11.4347 8.0771 15.0901 8.0771C18.7454 8.0771 21.7192 11.0102 21.7192 14.6154C21.7192 18.2206 18.7454 21.1537 15.0901 21.1537ZM15.0901 9.04495C11.9758 9.04495 9.44223 11.5439 9.44223 14.6154C9.44223 17.687 11.9758 20.1858 15.0901 20.1858C18.2043 20.1858 20.7379 17.687 20.7379 14.6154C20.7379 11.5439 18.2043 9.04495 15.0901 9.04495Z",
    fill: "#FA7548"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/marketing-icon.3cfc7a21.svg";
export { ForwardRef as ReactComponent };